<app-hero
	[title]="'hero.profile' | translate"
	imageDesktop="assets/hero/user-profile-hero-3840x400.jpg"
	imageMobile="assets/hero/user-profile-hero-768x180.jpg"
/>
<div class="profile-page mt-4">
	@if (isMobileView) {
		<button
			class="btn-back"
			(click)="goBackToMenu()"
			type="button"
		>
			<span class="arrow">‹</span>
			<span class="text">{{ "report.button.back" | translate }}</span>
		</button>

		@if (showRightPanel) {
			@switch (activeSection) {
				@case ("personal") {
					<div class="mobile-section-title">
						{{ "userProfile.userData" | translate }}
					</div>
				}
				@case ("dealer") {
					<div class="mobile-section-title">
						{{ "user.companyData" | translate }}
					</div>
				}
				@case ("payment") {
					<div class="mobile-section-title">
						{{ "userProfile.onlinePayment" | translate }}
					</div>
				}
				@case ("consents") {
					<div class="mobile-section-title">
						{{ "user.consents" | translate }}
					</div>
				}
			}
		}
	}

	<!-- LEFT PANEL -->
	<div
		class="profile-panel left"
		[class.hidden]="showRightPanel"
	>
		<ul class="profile-menu">
			<li
				[class.active]="activeSection === 'personal'"
				(click)="setSection('personal')"
			>
				{{ "userProfile.userData" | translate }}
			</li>
			<li
				[class.active]="activeSection === 'dealer'"
				(click)="setSection('dealer')"
			>
				{{ "user.companyData" | translate }}
			</li>

			@if (user.idMarket === "IT") {
				<li
					[class.active]="activeSection === 'payment'"
					(click)="setSection('payment')"
				>
					{{ "userProfile.onlinePayment" | translate }}
				</li>
			}

			<li
				[class.active]="activeSection === 'consents'"
				(click)="setSection('consents')"
			>
				{{ "user.consents" | translate }}
			</li>
		</ul>
	</div>

	<!-- RIGHT PANEL -->
	<div
		class="profile-panel right"
		[class.hidden]="!(showRightPanel && user)"
	>
		@switch (activeSection) {
			@case ("personal") {
				<div class="profile-card">
					<div class="info-grid">
						<div class="info-item">
							<label>{{ "userProfile.firstName" | translate }}</label>
							<span>{{ user.name }}</span>
						</div>

						<div class="info-item">
							<label>{{ "userProfile.lastName" | translate }}</label>
							<span>{{ user.surname }}</span>
						</div>

						<div class="info-item">
							<label>{{ "userProfile.birthDate" | translate }}</label>
							<span>{{ user.birthDate | date: "dd/MM/yyyy" }}</span>
						</div>
						@if (user.idMarket === "IT") {
							<div class="info-item">
								<label>{{ "userProfile.fiscalCode" | translate }}</label>
								<span>{{ user.fiscalCode }}</span>
							</div>
						}
						<div class="info-item">
							<label>{{ "userProfile.email" | translate }}</label>
							<span>{{ user.email }}</span>
							<!-- <input type="text" formControlName="email">-->
						</div>

						<!-- <div class="info-item">
							<label>{{ "userProfile.language" | translate }}</label>
							<select formControlName="preferredLanguage">
								@for (opt of languages; track opt) {
									<option [value]="opt">{{ opt }}</option>
								}
							</select>
						</div> -->
					</div>
				</div>
			}
			@case ("dealer") {
				<div class="profile-card">
					<div class="info-grid">
						@if (dealer) {
							<div class="info-item">
								<label>{{ "userProfile.businessName" | translate }}</label>
								<span>{{ dealer.businessName }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.address" | translate }}</label>
								<span>{{ dealer.address }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.city" | translate }}</label>
								<span>{{ dealer.city }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.postalCode" | translate }}</label>
								<span>{{ dealer.postalCode }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.country" | translate }}</label>
								<span>{{ dealer.country }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.referenceSurname" | translate }}</label>
								<span>{{ dealer.referenceSurname }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.vatCode" | translate }}</label>
								<span>{{ dealer.vatCode }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.email" | translate }}</label>
								<span>{{ dealer.email }}</span>
							</div>
							<div class="info-item">
								<label>{{ "userProfile.telephone" | translate }}</label>
								<span>{{ dealer.mobile }}</span>
							</div>
						}
					</div>
				</div>
			}
			@case ("payment") {
				<div class="profile-card">
					<form [formGroup]="dealerForm">
						<div class="info-item">
							<label for="templateName">{{ "userProfile.iban" | translate }}*</label>
						</div>
						<div class="mb-4">
							<mat-form-field
								appearance="fill"
								class="w-100"
							>
								<input
									matInput
									id="templateName"
									type="text"
									name="iban"
									formControlName="iban"
									maxlength="35"
									required
								/>
							</mat-form-field>
						</div>
						<div
							class="info-item"
							style="border-top: 1px solid #e0e2e6"
						>
							<span style="margin: 1rem 0">
								{{ "userProfile.onlinePaymentDisclaimer" | translate }}
							</span>
						</div>
						<div class="col-sm-12">
							<input
								type="checkbox"
								formControlName="flgOnlinePayment"
							/>
							<span style="margin-left: 8px">{{ "userProfile.acceptOnlinePayment" | translate }}</span>
						</div>
						<div class="col-sm-12 text-center">
							<span>
								<a
									(click)="onIban()"
									[class.disabled]="dealerForm.invalid"
									class="btn btn-blue btn-ico btn-ico-save-before text-uppercase"
								>
									{{ "userProfile.save" | translate }}
								</a>
							</span>
						</div>
					</form>
				</div>
			}
			@case ("consents") {
				<div
					class="profile-card"
					[formGroup]="userForm"
				>
					<div class="consent-row">
						<input
							type="checkbox"
							formControlName="consent1"
							id="consent1"
						/>
						<div class="info-item">
							<label>{{ "consenso-1.p1" | translate }}</label>
							<span>{{ "consenso-1.p2" | translate }}</span>
						</div>
					</div>

					@if (!["DE", "AT"].includes(user.idMarket)) {
						<div class="consent-row">
							<input
								type="checkbox"
								formControlName="consent2"
								id="consent2"
							/>
							<div class="info-item">
								<label>{{ "consenso-2.p1" | translate }}</label>
								<span>{{ "consenso-2.p2" | translate }}</span>
							</div>
						</div>
					}

					<div class="consent-row">
						<input
							type="checkbox"
							formControlName="consent3"
							id="consent3"
						/>
						<div class="info-item">
							<label>{{ "consenso-3.p1" | translate }}</label>
							<span>{{ "consenso-3.p2" | translate }}</span>
						</div>
					</div>

					<div class="text-center mt-4">
						<a
							(click)="onEdit()"
							[class.disabled]="userForm.invalid"
							class="btn btn-blue btn-ico btn-ico-save-before text-uppercase"
						>
							{{ "userProfile.edit" | translate }}
						</a>
					</div>
				</div>
			}
		}
	</div>
</div>